<template>
  <md-dialog :md-active.sync="visiable" :md-click-outside-to-close="false">
    <md-dialog-title>{{ $t("Update booking time") }}</md-dialog-title>

    <md-dialog-content>
      <div class="component-update-booking-time-pop">
        <div class="mt-10 date-container">
          <span class="title">{{ $t("Date") }}</span>
          <md-datepicker
            class="ml30"
            v-validate="'required'"
            v-model="startDate"
            name="startDate"
            :md-model-type="Number"
            md-immediately
          />
        </div>
        <div class="mt30">
          <span class="title">{{ $t("Time") }}</span>
          <span class="ml-10">
            <vue-timepicker
              drop-direction="up"
              v-validate="'required'"
              v-model="startTime"
              name="startTime"
              close-on-complete
            >
            </vue-timepicker>
            &nbsp;&nbsp; to &nbsp;&nbsp;
            <vue-timepicker
              drop-direction="up"
              v-validate="'required'"
              v-model="endTime"
              name="endTime"
              close-on-complete
            >
            </vue-timepicker>
          </span>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button @click="onclose && onclose()">Close</md-button>
      <md-button class="md-primary" @click="save">Save</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { updateBookingTime } from "@/services/flightReview.service.js";
import moment from "moment";

export default {
  components: {
    VueTimepicker
  },
  props: {
    visiable: Boolean,
    onclose: Function,
    onsave: Function,
    bookingInfo: Object,
    order_id: '',
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      startTime: undefined,
      endTime: undefined,
      startDate: undefined,
      disabledDates: date => {
        let now = new Date();
        return new Date(moment(+now).startOf("days")) > date;
      }
    };
  },
  methods: {
    save() {
      this.$validator.validateAll().then(async res => {
        if (!res) {
          this.$notify({
            message: this.$t("Please choose a time"),
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning",
            timeout: 3000
          });
          return;
        }

        let start = moment
          .duration(`${this.startTime["HH"]}:${this.startTime["mm"]}`, "HH:mm")
          .asSeconds();
        let end = moment
          .duration(`${this.endTime["HH"]}:${this.endTime["mm"]}`, "HH:mm")
          .asSeconds();
        
        if (start > end) {
          this.$notify({
            message: this.$t("Please enter a valid time"),
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning",
            timeout: 3000
          });
          return
        }
        let date = this.startDate / 1000;
        await updateBookingTime({
          order_id: this.order_id,
          item_id: this.bookingInfo._id.$oid,
          booking_start_time: date + start,
          booking_end_time: date + end
        });
        this.onsave && this.onsave();
      });
    }
  }
};
</script>

<style lang="scss">
.component-update-booking-time-pop {
  padding: 20px 16px;
  height: 220px;

  .title {
    width: 80px;
    display: inline-block;
  }
  .ml10 {
    margin-left: 10px;
  }

  .ml30 {
    margin-left: 30px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt30 {
    margin-top: 30px;
  }

  .date-container {
    display: inline-flex;
    align-items: center;

    .md-date-icon {
      display: none;
    }

    .md-datepicker:after {
      width: auto;
    }

    .md-field:before {
      background-color: transparent !important;
    }
  }
}
</style>
